enum EnumCurrency {
	Unknown = 0,
	USD = 1,
	RUB = 2,
	EUR = 3
}
export default EnumCurrency
